export default __webpack_public_path__ + "static/Decentralized-Networks-abc8bf675978bd4ebc26ffd5f3ae1347.webp";